import { Theme } from '../../base';

export default function Select(theme: Theme) {
    return {
        MuiSelect: {
            styleOverrides: {
                root: {
                    '&.MuiInputBase-sizeSmall': {
                        height: theme.componentSizes.small,
                        padding: theme.spacing(1),
                    },
                    '&.MuiInputBase-sizeMedium': {
                        height: theme.componentSizes.medium,
                        padding: theme.spacing(1),
                    },
                    '& .MuiInputLabel-root': {
                        textAlign: 'center',
                    },
                },
                select: {
                    '&.MuiInputBase-input': {
                        display: 'flex',
                        alignItems: 'center',
                        paddingInlineEnd: theme.spacing(3),
                        paddingInlineStart: theme.spacing(1.5),
                    },
                },
            },
        },
    };
}
